/*eslint-disable no-restricted-globals */
import { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from '../../../../api/axios';
import MasterPermissions from '../../../api/MasterPermissions';
import { components } from '../../common/auto-suggestion-select/AsyncSelect';
import { Search } from 'react-bootstrap-icons';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import { setClaimNumbersList } from 'src/redux/admin/uploadDocumentSlice';
import moment from 'moment';

const useUploadDocument = (userSpecDoc) => {
  const [files, setFiles] = useState([]);
  const [filesLoader, setfilesLoader] = useState(false);
  const [title, setTitle] = useState('');
  const [sendDocumentFor, setSendDocumentFor] = useState();
  const [referenceNumber, setReferenceNumber] = useState('');
  const [typeOptionList, setTypeOptionList] = useState([]);
  const [docType, setDocType] = useState();
  const [comments, setComments] = useState('');
  const [loadingApiConfig, setLoadingApiConfig] = useState(true);
  const [showUploadProgress, setShowUploadProgress] = useState(false);
  const [formOID, setSetFormOID] = useState('');
  const [formUploadStatus, setFormUploadStatus] = useState(false);
  const [fileUploadStatus, setFileUploadStatus] = useState('pending');
  const [fileProgress, setFileProgress] = useState(0);
  const [isOpenOverlayPopup, setIsOpenOverlayPopup] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [typeListValues, setTypeListValues] = useState([]);
  const [docTypeMeta, setDocTypeMeta] = useState({});
  const [locationTypeMeta, setLocationTypeMeta] = useState({});
  const [resetDocType, setResetDocType] = useState(false);
  const [physicianType, setPhysicianType] = useState();
  const [selectedDocTypeData, setSelectedDocTypeData] = useState();
  const [loadLocation, setLoadLocation] = useState(false);
  const [selectedLocationData, setSelectedLocationData] = useState();
  const [defaultLocationloader, setDefaultLocationloader] = useState(false);
  const [defaultValueskeletonLoader, setDefaultValueSkeletonLoader] =
    useState(false);
  const { appConfigs } = useSelector((state) => state.app);
  const brokerUserCreationSetting =
    appConfigs?.Network_Setting?.Broker_User_Creation_Setting;

  //For DEMO purpose: Temp line of code for unhappy scenario
  //const [ tempCounter, setTempCounter ] = useState( 0 );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { selectedMember, memberDetails, memberList } = useSelector(
    (state) => state.memberModule,
  );
  const { userData } = useSelector((state) => state.user);
  const DepOidInfo = memberDetails?.Member?.DependentsInfo;

  const onClickViewButton = () => {
    const tempState = userSpecDoc
      ? {
          selectedTabDocument: true,
        }
      : {
          documentDetailBackButton: true,
          ...location.state,
        };

    navigate(userSpecDoc ? '/admin/Messages-Documents' : '/admin/view-member', {
      state: tempState,
    });
  };

  const sendDocumentListDefaultValue = memberList.filter(
    (item) => item?.OID === selectedMember?.ID,
  );

  const getAllowedTypeOptions = (uniqueTypeData) => {
    const data = uniqueTypeData.filter((item) => {
      if (item.value === 'BROKER') {
        return userData.UserType === 'Broker'
          ? MasterPermissions.CheckPermission('Upload for self')
          : MasterPermissions.CheckPermission('Upload for Broker');
      } else if (item.value === 'DEPENDENT' || item.value === 'EMPLOYEE') {
        return MasterPermissions.CheckPermission('Upload for Members');
      } else if (
        item.value === 'PHYSICIAN' ||
        item.value === 'FACILITY' ||
        item.value === 'CONNECTOR'
      ) {
        return MasterPermissions.CheckPermission(
          'Upload for Physician/Facility',
        );
      } else if (item.value === 'CLIENT') {
        return MasterPermissions.CheckPermission('Upload for Client');
      } else if (item.value === 'Block of Business') {
        if (userData.UserType === 'Broker') {
          return (
            MasterPermissions.CheckPermission('Upload for BLOB') &&
            brokerUserCreationSetting
          );
        } else {
          return MasterPermissions.CheckPermission('Upload for BLOB');
        }
      } else if (item.value === 'Location') {
        return MasterPermissions.CheckPermission('Upload for Location');
      } else if (item.value === 'CLAIM') {
        return MasterPermissions.CheckPermission('Upload for Claims');
      } else {
        return false;
      }
    });
    return data;
  };
  //type field values calling
  const getTypeList = async () => {
    try {
      const responseDocument = await axiosInstance.get(
        APIEndpoints.getTypeValueUploadDocument(),
      );
      const documentListData =
        responseDocument.data.Response.documentEntityDetailRespDTO;

      console.log('documentListData--@', documentListData);
      const responseList = documentListData.map((item) => {
        return {
          label: item.JmpEntityType,
          value: item.CoreEntityType,
          Oid: item.Oid,
        };
      });

      const uniqueTypeData = [];
      for (let i = 0; i < responseList.length; i++) {
        if (
          !uniqueTypeData.find((item) => item.label === responseList[i].label)
        ) {
          uniqueTypeData.push(responseList[i]);
        }
      }
      const permittedData = getAllowedTypeOptions(uniqueTypeData);
      setTypeListValues(documentListData);
      //Based on Discussion with Ramesh not need Claims and Eligibility as document for these we can not show on list
      setTypeOptionList(permittedData);
      setLoadingApiConfig(false);
    } catch (err) {
      return;
    }
  };

  useEffect(() => {
    getTypeList();
  }, []);

  useEffect(() => {
    if (!(docType === undefined)) {
      let data = {};
      switch (docType.value) {
        case 'Block of Business':
          data = {
            Buttonlabel: 'Select Block of Business',
            titleLabel: 'Block of Business(es)',
            subtitleLabel: 'Block of Business',
            displayLabel: 'BlkOfBusName',
            displayId: 'BlkOfBusId',
            labelIdText: 'BLOB ID',
            displaySubLabel: 'All Employers',
          };
          break;
        case 'CLIENT':
          data = {
            Buttonlabel: 'Select Employer',
            titleLabel: 'Employer(s)',
            subtitleLabel: 'Employer',
            displayLabel: 'ClientName',
            displayId: 'ClientId',
            labelIdText: 'EMPLOYER ID',
            displaySubLabel: 'All Locations',
          };
          break;
        case 'Location':
          data = {
            Buttonlabel: 'Select Employer',
            titleLabel: 'Employer(s)',
            subtitleLabel: 'Employer',
            displayLabel: 'ClientName',
            displayId: 'ClientId',
            labelIdText: 'EMPLOYER ID',
            displaySubLabel: 'All Locations',
          };
          break;
        case 'BROKER':
          data = {
            Buttonlabel: 'Select Broker',
            titleLabel: 'Broker(s)',
            subtitleLabel: 'Broker',
            displayLabel: 'BrokerName',
            displayId: 'Code',
            labelIdText: 'Tax ID',
            displaySubLabel: 'TaxID',
          };
          break;
        case 'PHYSICIAN':
        case 'CONNECTOR':
        case 'FACILITY':
          data = {
            Buttonlabel: 'Select Facility',
            ExtraButtonLabel: 'Select Doctor',
            titleLabel: `${physicianType === 'D' ? 'Doctors' : 'Facilities'}`,
            subtitleLabel: `${
              physicianType === 'D' ? 'Doctors' : 'Facilities'
            }`,
            displayLabel: `${
              physicianType === 'D' ? 'LastName' : 'FacilityName'
            }`,
            displayId: `${
              physicianType === 'D' ? 'PhysicainOid' : 'FacilityOID'
            }`,
            labelIdText: 'Tax ID',
            rightValueForLocationDisplayID: `${
              physicianType === 'D' ? 'TaxID' : 'TaxId'
            }`,
            displaySubLabel: '',
          };
          break;
        case 'EMPLOYEE':
          data = {
            Buttonlabel: 'Select Member/Dependent',
            titleLabel: 'Member/Dependent',
            subtitleLabel: 'Member/Dependent',
            displayId: 'OID',
            labelIdText: 'Member ID',
          };
          break;
        case 'DEPENDENT':
          data = {
            Buttonlabel: 'Select Member/Dependent',
            titleLabel: 'Member/Dependent',
            subtitleLabel: 'Member/Dependent',
            displayId: 'OID',
            labelIdText: 'Member ID',
          };
          break;
      }
      setDocTypeMeta(data);
      loadLocation &&
        setLocationTypeMeta({
          Buttonlabel: 'Select Location',
          titleLabel: 'Location(s)',
          subtitleLabel: 'Location',
          displayLabel: 'LocationName',
          displayId: 'oid',
          labelIdText: 'Client ID',
          rightValueForLocationDisplayID: 'ClientId',
          displaySubLabel: '',
        });
    }
  }, [docType, physicianType, loadLocation]);

  const getOIDs = () => {
    const sendForEmployee = Boolean(
      selectedMember?.ID === memberDetails?.Member?.OID,
    );
    const sendForDependent =
      DepOidInfo &&
      Boolean(
        DepOidInfo.filter((dependent) => dependent.OID === selectedMember?.ID)
          .length,
      );

    return sendForEmployee
      ? { MemberOid: memberDetails?.Member?.OID, DependentOid: '' }
      : sendForDependent
      ? {
          MemberOid: memberDetails?.Member?.OID,
          DependentOid: selectedMember?.ID,
        }
      : { MemberOid: '', DependentOid: '' };
  };

  const getSelectedUserOid = () => {
    const sendForEmployee = Boolean(
      selectedDocTypeData?.MemberType === 'Member',
    );
    const sendForDependent = Boolean(
      selectedDocTypeData?.MemberType === 'Dependent',
    );

    return sendForEmployee
      ? { MemberOid: selectedDocTypeData?.OID, DependentOid: '' }
      : sendForDependent
      ? {
          MemberOid: '',
          DependentOid: selectedDocTypeData?.OID,
        }
      : { MemberOid: '', DependentOid: '' };
  };

  const getDocTypeOIDs = () => {
    return docType.value === 'Block of Business'
      ? { BlockofBusinessOid: selectedDocTypeData.oid }
      : docType.value === 'CLIENT'
      ? {
          BlockofBusinessOid: selectedDocTypeData.BlkOfBusOid,
          ClientOid: selectedDocTypeData.oid,
        }
      : docType.value === 'Location'
      ? {
          BlockofBusinessOid: selectedDocTypeData.BlkOfBusOid,
          ClientOid: selectedDocTypeData.oid,
          LocationOid: selectedLocationData.oid,
        }
      : docType.value === 'BROKER'
      ? {
          BrokerCode: selectedDocTypeData.Code,
        }
      : docType.value === 'PHYSICIAN' ||
        docType.value === 'CONNECTOR' ||
        docType.value === 'FACILITY'
      ? physicianType === 'D'
        ? {
            ConnectorID: '',
            PhysicianID: selectedDocTypeData.PhysicianID,
            PhysicianOid: selectedDocTypeData.PhysicainOid,
            FacilityOid: '',
          }
        : { FacilityOid: selectedDocTypeData.FacilityOID }
      : {};
  };
  const getEntityAttributes = (CoreEntityType, ImageType) => {
    return docType.value === 'PHYSICIAN' ||
      docType.value === 'CONNECTOR' ||
      docType.value === 'FACILITY'
      ? physicianType === 'D'
        ? {
            EntityType: 'PHYSICIAN',
            EntityDesc: 'PHYSICIAN',
            ImageType: 'Web_Physician',
            ImageDesc: 'Web_Physician',
          }
        : {
            EntityType: 'FACILITY',
            EntityDesc: 'FACILITY',
            ImageType: 'Web_Facility',
            ImageDesc: 'Web_Facility',
          }
      : {
          EntityType: CoreEntityType,
          EntityDesc: CoreEntityType,
          ImageType: ImageType,
          ImageDesc: ImageType,
        };
  };

  const schema = yup.object({
    senddocumentfor: yup.string().nullable(),
    title: yup.string().required('Enter Title '),
    referenceNumber: yup.string().when('type', {
      is: (val) => val?.label === 'Claims',
      then: () => yup.string().required('Please select a claim number'),
    }),
    type: yup.object().required('Please select a type').nullable(),
    comments: yup.string(),
    file: yup.object().required('please select file').nullable(),
  });

  const uploadFormData = async (values) => {
    const filteredVal = typeListValues.filter(
      (item) => item?.Oid === values?.type?.Oid,
    );

    try {
      const memberDependentOID = userSpecDoc ? getSelectedUserOid() : getOIDs();
      const docTypeOID = getDocTypeOIDs();
      const entityAttributes = getEntityAttributes(
        filteredVal[0].CoreEntityType,
        filteredVal[0].ImageType,
      );
      const payLoad = {
        //EntityType: filteredVal[0].CoreEntityType,
        //EntityDesc: filteredVal[0].CoreEntityType,
        JMPEntityType: filteredVal[0].JmpEntityType,
        Title: title,
        ReferenceNumber: userSpecDoc ? referenceNumber : referenceNumber?.value,
        //ImageType: filteredVal[0].ImageType,
        //ImageDesc: filteredVal[0].ImageType,
        Totaldocument: Object.keys(values.file).length,
        UploadedByOid: userData.Oid,
        Comment: comments,
        MemberType: selectedMember.mType
          ? selectedMember.mType
          : selectedDocTypeData?.MemberType
          ? selectedDocTypeData?.MemberType === 'Member'
            ? 'Employee'
            : 'Dependent'
          : '',
        ...entityAttributes,
        ...memberDependentOID,
        ...docTypeOID,
      };

      //For DEMO purpose: Temp line of code for unhappy scenario
      //const tempPayLoad = {};

      //For DEMO purpose: replace tempPayLoad with payLoad
      const form = await axiosInstance.post(
        APIEndpoints.postFormDataUploadDocument(),
        payLoad,
      );
      //console.log( 'formBatchOid', form?.data?.Response?.oid );
      const formOID = form?.data?.Response;

      setSetFormOID(formOID);
      setFormUploadStatus(true);
      //Upload Files
      await initiateFileUpload(files, formOID);
      setfilesLoader(true);
    } catch (e) {
      setServerError(true);
    }
  };

  const checkValidClaim = async (claimNumber) => {
    try {
      const data = await axiosInstance.get(
        `${APIEndpoints.searchClaimsIndependently()}Claimnumber/${claimNumber}`,
      );
      console.log('isValidClaim data', data);
      return data.status === 200;
    } catch (e) {
      toast.error(
        <ToastMessage
          type="error"
          subTitle={
            'Invalid Claim Number! Try again with another Claim Number.'
          }
        />,
      );
      return false;
    }
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result
          .replace('data:', '')
          .replace(/^.+,/, '');
        return resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });

  const uploadFiles = async (fileItem, formOID, index) => {
    let percent = 0;
    const config = {
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        percent = Math.floor((loaded * 100) / total);
        if (percent <= 100) {
          setFileProgress(percent);
          setFiles((current) =>
            current.map((obj, i) => {
              if (i === index) {
                return { ...obj, uploadPercent: percent };
              }
              return obj;
            }),
          );
        }
      },
    };

    const payLoad = {
      DocControlNo: '',
      PDFLocation: '',
      OrigFileName: fileItem.file.name,
      chgUser: 'Test',
      chgts: '',
      LinkType: 'Image',
      Description: title,
      Notes: formOID.JVComment,
      ReceivedDate: '',
      ReceivedTime: '',
      EntityKey: formOID['ReferenceNumber/EntityKey'],
      EntityDesc: formOID.EntityDesc,
      EntityType: formOID.EntityType,
      ImageType: formOID.ImageType,
      UploadedBatchOid: formOID.UploadedBatchOid,
      StringContAFile: await fileToBase64(fileItem.file),
    };

    return axiosInstance
      .post(APIEndpoints.postFileDataUploadDocument(), payLoad, config)
      .then((res) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'uploaded' };
            }
            return obj;
          }),
        );
        return res;
      })
      .catch((err) => {
        setFiles((current) =>
          current.map((obj, i) => {
            if (i === index) {
              return { ...obj, uploadStatus: 'failed' };
            }
            return obj;
          }),
        );
        return Promise.reject(err);
      });
  };

  const initiateFileUpload = (files, formOID) => {
    const uploadPromises = files.map((fileItem, index) => {
      //For DEMO purpose: Temp line of code for unhappy scenario
      //const tempOID = ( index === 0 || tempCounter === 2 ) ? formOID : 'formOID';

      if (fileItem.uploadStatus !== 'uploaded') {
        //For DEMO purpose: replace formOID with tempOID
        return uploadFiles(fileItem, formOID, index);
      }
      return;
    });

    Promise.all(uploadPromises)
      .then(() => {
        setFileUploadStatus('uploaded');
      })
      .catch(() => {
        setFileUploadStatus('failed');
      });
  };

  const submitData = async (values) => {
    console.log('VALUESSS', values);

    //Show overlay
    //overlay accessibility
    setIsOpenOverlayPopup(true);

    //Upload Form Data and get OID
    uploadFormData(values);
  };

  const uploadDone = () => {
    history.go('/admin/upload-document');
    //setShowUploadProgress( false );
    //setIsOpenOverlayPopup( false );
    //backToDocumentPageFocus();
  };

  const retryUploadAllFiles = async () => {
    //For DEMO purpose: Temp line of code for unhappy scenario
    //setTempCounter( counter => counter + 1 );
    setFileUploadStatus('pending');

    const retryFiles = files.map((file) =>
      file.uploadStatus === 'failed'
        ? { ...file, uploadStatus: 'pending', uploadPercent: 0 }
        : file,
    );
    setFiles(retryFiles);
    await initiateFileUpload(files, formOID);
    setfilesLoader(true);
  };

  const CustomSearchIcon = (props) => (
    <components.DropdownIndicator {...props}>
      <Search color="black" />
    </components.DropdownIndicator>
  );

  const [searchedClaimOptions, setSearchedClaimOptions] = useState([]);
  const [searchedDebounce, setsearchedDebounce] = useState('');
  const [claimNumberText, setClaimNumberText] = useState('');
  const [claimNumberLoading, setClaimNumberLoading] = useState(false);
  const {
    appConfigs: { Common_Setting },
  } = useSelector(({ app }) => app);

  const FormatOptionLabel = (props) => {
    if (!props?.data?.data?.Claimnumber && !props?.data?.data?.ServiceDate) {
      return '';
    }
    const { Claimnumber, ServiceDate } = props.data.data;
    return (
      <components.Option {...props}>
        <div className="custom-select-options">
          <div className="select-options-content">
            <div className="d-flex">
              <div>{Claimnumber}</div>
            </div>
            <div>Service Date : {ServiceDate}</div>
          </div>
        </div>
      </components.Option>
    );
  };

  const dispatch = useDispatch();
  const { claimNumbersList } = useSelector(
    (state) => state?.uploadDocumentAdmin,
  );

  const claimsYearRange =
    Common_Setting?.Claims_Year_Range != undefined
      ? Common_Setting?.Claims_Year_Range
      : 5;

  //Fetching Claims summary
  const fetchClaimsSummary = async () => {
    setClaimNumberLoading(true);
    const oid = selectedMember?.ID;
    const memType =
      selectedMember?.mType === 'Employee' ? 'Family' : selectedMember?.mType;
    try {
      if (selectedMember?.mType) {
        const fromDate = new Date().getFullYear() - claimsYearRange + '-01-01';
        const toDate = moment(new Date()).format('YYYY-MM-DD');
        let claimResultSet = [];
        const claimsResponse = await axiosInstance.get(
          APIEndpoints.getClaimsListResource() +
            memType +
            '/oid/' +
            oid +
            '/AdminCenter/true' +
            '/pageSize/5000/incurreddatefrom/' +
            fromDate +
            '/incurreddateto/' +
            toDate,
        );
        claimResultSet = claimsResponse.data.Response.Claims;
        claimResultSet.sort(
          (a, b) => new Date(b.ServiceDate) - new Date(a.ServiceDate),
        );

        const FILTERED_DATA = claimResultSet?.map((item) => {
          return {
            label: item?.Claimnumber,
            value: item?.Claimnumber,
            data: item,
          };
        });

        setSearchedClaimOptions(FILTERED_DATA);
        dispatch(setClaimNumbersList(FILTERED_DATA));
        return FILTERED_DATA;
      }
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      setClaimNumberLoading(false);
    }
  };

  const searchClaims = () => {
    const temp = claimNumbersList?.filter((item) =>
      item.value.includes(claimNumberText),
    );
    setSearchedClaimOptions(temp?.slice(0, 25));
    console.log('temp', temp);
  };

  const debouncedCall = useCallback(
    debounce((currentVal) => setsearchedDebounce(currentVal), 800),
    [],
  );

  const onSearch = (event) => {
    if (event !== '') {
      setClaimNumberLoading(true);
    } else {
      setClaimNumberLoading(false);
    }
    setClaimNumberText(event);
    debouncedCall(event);
  };

  useEffect(() => {
    fetchClaimsSummary();
  }, []);

  useEffect(() => {
    if (claimNumberText.length >= 3) {
      searchClaims();
    }
    setClaimNumberLoading(false);
  }, [searchedDebounce]);

  return {
    files,
    filesLoader,
    title,
    sendDocumentFor,
    referenceNumber,
    docType,
    docTypeMeta,
    comments,
    schema,
    formRef,
    sendDocumentListDefaultValue,
    typeOptionList,
    loadingApiConfig,
    showUploadProgress,
    isOpenOverlayPopup,
    formUploadStatus,
    fileUploadStatus,
    fileProgress,
    serverError,
    loadLocation,
    locationTypeMeta,
    setLoadLocation,
    setShowUploadProgress,
    setFiles,
    setfilesLoader,
    setTitle,
    setSendDocumentFor,
    setReferenceNumber,
    setDocType,
    setComments,
    submitData,
    getTypeList,
    setTypeOptionList,
    setIsOpenOverlayPopup,
    uploadDone,
    retryUploadAllFiles,
    onClickViewButton,
    resetDocType,
    setResetDocType,
    physicianType,
    setPhysicianType,
    selectedDocTypeData,
    setSelectedDocTypeData,
    selectedLocationData,
    setSelectedLocationData,
    defaultLocationloader,
    setDefaultLocationloader,
    defaultValueskeletonLoader,
    setDefaultValueSkeletonLoader,
    CustomSearchIcon,
    FormatOptionLabel,
    fetchClaimsSummary,
    claimNumberLoading,
    searchedClaimOptions,
    defaultClaimList: claimNumbersList?.slice(0, 5),
    claimNumberText,
    onSearch,
    checkValidClaim,
  };
};
//57

export default useUploadDocument;
